// src/Register.jsx
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Register.css"; // 👈 Make sure this exists

const backgroundStyle = {
  background: "url('/background.png') center/cover no-repeat",
  minHeight: "100vh"
};

function Register() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [paymentDetails, setPaymentDetails] = useState("");
  const [resumeLink, setResumeLink] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const response = await fetch("http://localhost:5002/auth/register", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        username,
        password,
        email,
        payment_details: paymentDetails,
        resume_link: resumeLink,
      }),
    });

    const data = await response.json();

    if (response.ok) {
      alert(data.message);
      navigate("/login");
    } else {
      alert(data.error);
    }
  };

  return (
    <div className="register-page" style={backgroundStyle}>
      <div className="register-box">
        <h1 className="register-title">SIGN UP</h1>
        <form onSubmit={handleSubmit}>
          <label>Username/ Email</label>
          <input
            type="text"
            placeholder="Username"
            onChange={(e) => setUsername(e.target.value)}
            required
          />

          <label>Password</label>
          <input
            type="password"
            placeholder="Password"
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <label>Contact No</label>
          <input
            type="email"
            placeholder="Email"
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <label>Payment details (UPI ID/ Bank details)</label>
          <input
            type="text"
            placeholder="Payment Details"
            onChange={(e) => setPaymentDetails(e.target.value)}
            required
          />

          <label>Resume link</label>
          <input
            type="text"
            placeholder="Resume link"
            onChange={(e) => setResumeLink(e.target.value)}
          />

          <p className="login-link">
            Already have an account?{" "}
            <span onClick={() => navigate("/login")}>click here to login</span>
          </p>

          <button type="submit" className="register-button">
            Sign Up
          </button>
        </form>
      </div>
    </div>
  );
}

export default Register;
